import React, { memo, useCallback, useEffect, useRef } from "react";

import { usePreviewBox } from "../../hooks/usePreviewBox";
import { useResizeObserver } from "../../hooks/useResizeObserver"; // Copied form intellisense
import { getOffset } from "../../utils/dom";

import "./preview-box.css";

/**
 * This component's purpose is to measure the position of this DOM element
 * and send that information to the Preview.
 * At this way we can position the preview with paddings, without changing the preview element size */
export const PreviewBox = memo(function PreviewBox() {
	const ref = useRef<HTMLDivElement>(null);

	const { updatePreviewBox } = usePreviewBox();

	function getProductRect(el: HTMLElement) {
		const boundingBox = el.getBoundingClientRect();
		const offset = getOffset(el); // use getOffset to prevent problem on iOS when OSK is open
		return eXpress.math.rect(offset.left, offset.top, boundingBox.width, boundingBox.height);
	}

	useEffect(() => {
		if (!ref.current) return;
		updatePreviewBox(getProductRect(ref.current));
	}, [updatePreviewBox]);

	useResizeObserver(
		ref,
		useCallback(
			(_contentRect, target) => {
				// Needed to measure the target, the contextRect did not include top/left
				updatePreviewBox(getProductRect(target));
			},
			[updatePreviewBox],
		),
	);

	return <div className="preview-box" ref={ref} />;
});
